import { useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
// import ProgrammableKeysView from "./ProgrammableKeysView"
import UMCContentSplitLayout from "../common/UMCContentSplitLayout"
import UMCAttrComponentView from "../common/UMCAttrComponentView"
import { setProgKeysSumDetailSchema } from "../../store/reducers/ProgKeysReducer"
import { getSchemaDomains } from "../../store/actions/CommonActions"
import { UUM_URL } from "../../utils/Config"

const CreateKeyProfileView = (props) => {
    const [domain_1View, setDomain_1View] = useState("")
    const [domain_2View, setDomain_2View] = useState("")
    const progKeysSumDetailSchema = useSelector((state) => state.progkeys.progKeysSumDetailSchema)

    const dispatch = useDispatch()

    useEffect(() => {
        if (!progKeysSumDetailSchema?.length) {
            const request = { url: `${UUM_URL}/schema/detail/keysprofile`, action: setProgKeysSumDetailSchema }
            dispatch(getSchemaDomains(request))
        }
    }, [])

    useEffect(() => {
        if (progKeysSumDetailSchema?.length) {
            const domain1View = getDomain1Content(progKeysSumDetailSchema[0]?.attribute)
            setDomain_1View(domain1View)

            const domain2View = getDomain2Content()
            setDomain_2View(domain2View)
        }
    }, [progKeysSumDetailSchema])

    const getDomain1Content = (attributes) => {

        const view = attributes.map((attr, index) => {
            return <UMCAttrComponentView attribute={attr} key={index} />
        })

        return view
    }

    const getDomain2Content = () => {
        // return <ProgrammableKeysView />
    }

    return <UMCContentSplitLayout
        domain_1={domain_1View}
        domain_2={domain_2View}
        heading_1={"New key profile"}
        okBtnLabel={"Next"}
        goBackHandler={() => props.setListViewMode && props.setListViewMode(true)}
    />
}

export default CreateKeyProfileView